// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__37QPh","split":"Layout_split__CPbe4","splitLeft":"Layout_splitLeft__v3jRK","splitRight":"Layout_splitRight__WM9G4","main":"Layout_main__5slkn"};